import { HEXColor } from '@neptune/colors-domain';

export enum HistogramType {
  Counting = 'COUNTING',
  Density = 'DENSITY',
}

export type HistogramSeriesData = {
  id: string;
  values: number[];
};

export type HistogramColumnData = {
  idx: number;
  series: Record<string, HistogramSeriesData>;
};

export type HistogramSeries = {
  attribute: string;
  entityId: string;
  shortId: string;
  projectIdentifier: string;
  color: HEXColor;
};

export type HistogramData = {
  edges: number[];
  columnsData: HistogramColumnData[];
  type: HistogramType;
  series: HistogramSeries[];
  maxValuePerSeries: Record<string, number>;
};
